








































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { MPListings } from '@/MPListings'
import { SimpleSet } from '@/SimpleSet'
import { MomentMPListing, sortOrderTypes } from '@/MomentMPListing'
import * as utils from '@/utils';
import * as utils_topshot from '@/utils_topshot';
import * as utils_time from '@/utils_time';
import MomentMPListingListComponent from '@/components/MomentMPListingListComponent.vue';                               // @ is an alias to /src
import { IPaginationResult } from '@/PaginationResult'
import GenericDropdown from '@/components/GenericDropdown.vue';                         // @ is an alias to /src
import { selectOption } from '@/components/GenericDropdown.vue';                         // @ is an alias to /src
import { Challenge } from '@/Challenge'
import { modeType } from '@/views/Challenges.vue';                         // @ is an alias to /src
import { RawLocation } from 'vue-router';
import { Plotly } from '@rleys/vue-plotly-basic'

@Component({
  name: 'ChallengesComponent',
  components: { MomentMPListingListComponent, GenericDropdown, Plotly }
})
export default class MPListingsComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop()
  public challengeID: string

  @Prop()
  public mode: modeType

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public moments: MomentMPListing[] = []
  public mpListings: MPListings = null
  public paginationResult: IPaginationResult = null
  public numMoments: number = null
  public totalCost: number = null
  public numUsersCompleted: number = null
  public whenEnds: string = null
  public challengeObject: Challenge = null

  // UI and filter options
  public challenge: { label: string, challengeID: string } = { label: 'Choose a Challenge', challengeID: null }
  public sortOrder: sortOrderTypes = 'ListedPrice_ASC'
  public challenges: Array<{ label: string, challengeID: string }> = []

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }


  // events from MomentMPListingListComponent
  public async onDrill(moment: MomentMPListing) {
    // `/listings/topshot?sortOrder=ListedPrice_ASC&setID=${this.setID}&playID=${this.playID}`
    const url: string = moment.getLiveTokenSearchLink() + '&noSelector=true'

    // same tab
    // const whereToGo: RawLocation = { path: url }
    // await this.$router.push(whereToGo)

    // new tab
    if (url) window.open(url, "_blank"); 
  }

  public async onChangedSort(sortOrder: sortOrderTypes) {
    this.sortOrder = sortOrder
    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }
  @Watch('challenge')
  public async onChangedChallenge(challenge: { label: string, challengeID: string }) {
    this.challenge = challenge ? challenge : { label: 'Choose a Challenge', challengeID: null }
    this.moments = []
    this.numMoments = 0
    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  public async infiniteHandler(state: any): Promise<void> {
    const numReturned: number = await this.fetchData(true, this.pageNumberToLoadNext)
    if (numReturned === 0) {
      if (this.$store.state.devmode) console.log(`infiniteHandler(): state.complete after getting 0 items`)
      state.complete()
    } else {
      state.loaded();
    }
  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean;
  private pageNumberToLoadNext: number = 1
  private challengeIDToUseWhenReady: string = null

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`);

    (this.$refs.SortDropdown as GenericDropdown).setOptions(
      [
        { text: 'Sort by Lowest Ask', value: 'ListedPrice_ASC' },
        // { text: 'Sort by Asking (highest)', value: 'ListedPrice_DESC' },
        { text: 'Sort by Best Deal', value: 'Discount_DESC' },
        // { text: 'Sort by Worst Deal', value: 'Discount_ASC' },
        // { text: 'Sort by Serial (lowest)', value: 'Serial_ASC' },
        // { text: 'Sort by Serial (highest)', value: 'Serial_DESC' },
        // { text: 'Sort by FMV (highest)', value: 'FMV_DESC' },
        // { text: 'Sort by FMV (lowest)', value: 'FMV_ASC' },

      ]
    );

    // from prop
    this.challengeIDToUseWhenReady = this.challengeID

    // from url
    if (this.$route.query.challengeID) this.challengeIDToUseWhenReady = this.$route.query.challengeID as string

    await this.fetchData(false, this.pageNumberToLoadNext)

  }
  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

  // add flowAddresses as query params to current url path
  private addParamsToURL() {
    let extra: string = ''
    if (this.challenge && this.challenge.challengeID) extra += `&challengeID=${encodeURIComponent(this.challenge.challengeID)}`
    extra = extra.replace('&', '?')     // replace only the first one
    this.$router.replace(`${this.$route.path}${extra}`).catch(() => {})
  }

  // the reason for pageNumberWhenCalled is for race-condition prevention
  private async fetchData(calledByInfiniteHandlerOrTimer: boolean, pageNumberWhenCalled: number): Promise<number> {
    this.addParamsToURL()

    const header: MomentMPListing = new MomentMPListing(null)
    header.momentID = 0
    header.valueFMV = 0

    let url: string = utils.getURLprefix() + `/api/topshot/mplistings/`;
    url += `?page=${pageNumberWhenCalled}`;
    url += `&sortOrder=${this.sortOrder}`;
    if (this.challenge) url += `&challengeID=${this.challenge.challengeID}`
    url += `&sc=true`
    url += `&challengeMode=${this.mode}`     // let's the API know that this is ChallengesComponent calling and to send back allChallenges

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url || calledByInfiniteHandlerOrTimer) {
        if (this.$store.state.devmode) console.log(`ChallengesComponent.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;
    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // whoa, we got another call after this one, so let's abort this one cuz the latest one should take precedent
      if (this.lastFetchedURL !== url) return

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      // challenges
      if (response.data.challenges) utils_topshot.setChallenges(response.data.challenges.map((po) => new Challenge(po)))
      if (response.data.expiredChallenges) utils_topshot.setExpiredChallenges(response.data.expiredChallenges.map((po) => new Challenge(po)))

      let allChallenges: Challenge[]
      if (response.data.allChallenges) {
        allChallenges = response.data.allChallenges.map((po) => new Challenge(po))
        this.challenges = [ { label: 'Choose a Challenge', challengeID: null } ]
        for (const challenge of allChallenges) this.challenges.push({ label: challenge.userChallenge.name, challengeID: challenge.topShotGUID });
      }

      // load up the MPListings
      if (!response.data.mpListings) {
        this.moments = []

        // process playerNameToUseWhenReady and setIDToUseWhenReady
        let needToRefetch: boolean = false
        if (this.challengeIDToUseWhenReady !== null) {
          this.challenge = this.challenges.find((c) => c.challengeID === this.challengeIDToUseWhenReady)
          needToRefetch = true
        }
        this.challengeIDToUseWhenReady = null
        if (needToRefetch) {
          this.pageNumberToLoadNext = 1
          await this.fetchData(false, this.pageNumberToLoadNext)
        }
        return 0
      }
      this.mpListings = new MPListings(response.data.mpListings)

      // load up stats
      if (response.data.numMoments) {
        this.numMoments = response.data.numMoments
        this.totalCost = response.data.totalCost
        this.challengeObject = utils_topshot.getChallengeByChallengeID(allChallenges, this.challenge.challengeID)
        this.numUsersCompleted = this.challengeObject.userChallenge.numUsersCompleted || this.challengeObject.lastNumCompleted || 0
        this.whenEnds = this.challengeObject.userChallenge.expirationDate.toLocaleString()
        this.challengeObject.generateGraphData()
      }

      this.addParamsToURL()

      // pagination result
      this.paginationResult = response.data.paginationResult

      // load up the moments separately from the MPListings object in case we want to do paging (might do everything inside MPListings eventually)
      let newRawItems: MomentMPListing[] = response.data.mpListings.moments
      if (newRawItems) {
        newRawItems = newRawItems.map((po) => new MomentMPListing(po));
        if (pageNumberWhenCalled === 1) this.moments = [ header ].concat(newRawItems);
        else this.moments = this.moments.concat(newRawItems)
        
        this.pageNumberToLoadNext++
        this.lastFetchSucceeded = true

        return newRawItems.length
      } else {
        this.lastFetchSucceeded = false;
        return 0
      }
    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

    if (this.$store.state.devmode) utils.toast(this, 'DEBUGGING', `Loaded ${this.moments.length} moments}`)
  }
}
